import { OrderItemGroupData } from '../../../app/data/model';
import { AsyncCommand } from '../../../app/shared/common';
import { CartItemContextCommand, ILabeledAction } from '../../cart/CartItem/CartItemState';

export type IOrderItemContextAction = ILabeledAction<OrderItemGroupData>;

export class OrderItemGroupState {
  public readonly reorderCommand: AsyncCommand;
  public readonly contextCommands: CartItemContextCommand[];

  constructor(
    public readonly item: OrderItemGroupData,
    private readonly reorder: (configurationCode: string) => Promise<void>,
    private readonly contextActions: IOrderItemContextAction[] = [],
  ) {
    this.reorderCommand = new AsyncCommand(async () => {
      await this.reorder(this.item.modularCode);
    });

    this.contextCommands = this.contextActions.map<CartItemContextCommand>((action) => ({
      label: action.label,
      command: new AsyncCommand(async () => await action.action(this.item)),
    }));
  }
}
